<template>
  <div class="nk-app-root">

    <div class="nk-main ">
      <div class="nk-wrap ">
        <div class="nk-header nk-header-fixed is-light">
          <div class="container-fluid">
            <div class="nk-header-wrap">
              <div class="nk-menu-trigger d-xl-none ms-n1"><a href="#" @click="toggleMenu" class="nk-nav-toggle nk-quick-nav-icon"
                ><em class="icon ni ni-menu"></em></a></div>
              <div class="nk-header-app-name">
                <div class="nk-header-app-logo"><em class="icon ni ni bg-purple-dim"></em>
                </div>
                <div class="nk-header-app-info"><span class="sub-text">Tfon Makine</span><span
                    class="lead-text">Fuar Görüşme Takip Uygulaması</span></div>
              </div>

              <div class="nk-header-tools">
                <ul class="nk-quick-nav">

         
        
                  <li class="dropdown user-dropdown"><a href="#" class="dropdown-toggle me-n1"
                      data-bs-toggle="dropdown">
                      <div class="user-toggle">
                        <div class="user-avatar sm"><em class="icon ni ni-user-alt"></em></div>
                      </div>
                    </a>
                    <div class="dropdown-menu dropdown-menu-md dropdown-menu-end">
                      <div class="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                        <div class="user-card">

                          <div class="user-avatar">  <img :src="$globalVariable.uploadUrl + profil.profil"  @error="$globalVariable.varsayilanGorsel" > </div>
                          <div class="user-info">
                            <span class="lead-text">{{ profil.ad }} {{ profil.soyad }}</span>
                            <span class="sub-text">{{ profil.rol }}</span>
                          </div>

                        </div>
                      </div>
                     
                     
          
                      <div class="dropdown-inner">
                        <ul class="link-list">
                          <li>  <router-link to="/profil"><em class="icon ni ni-user-alt"></em><span>Profil</span> </router-link></li>
                          <li>  <router-link to="/profil"><em class="icon ni ni-activity-alt"></em><span>Aktiviteler</span> </router-link></li>
                        </ul>
                      </div>
                      <div class="dropdown-inner">
                        <ul class="link-list">
                          <li> <a @click="this.$globalVariable.cikisYap"><em class="icon ni ni-signout"></em><span>Çıkış Yap</span> </a></li>
                        </ul>
                      </div>


                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="nk-sidebar" id="menuYan">
          <div class="nk-sidebar-inner" data-simplebar>
            <ul class="nk-menu nk-menu-md">
              <li class="nk-menu-heading">
                <h6 class="overline-title text-primary-alt">Anasayfa</h6>
              </li>

              <li class="nk-menu-item " :class="aktifSayfa('/anasayfa')">
                <router-link to="/anasayfa" class="nk-menu-link">
                  <span class="nk-menu-icon ">
                    <em class="icon ni ni-dashboard"></em>
                  </span>
                  <span class="nk-menu-text">Anasayfa</span>
                </router-link>
              </li>


              <li class="nk-menu-heading">
                <h6 class="overline-title text-primary-alt">Görüşmeler</h6>
              </li>

             
              <li class="nk-menu-item" v-if="yetki_kontrol('gorusmebilgi_ekle')"  :class="aktifSayfa('/gorusmeform/0')">
                <router-link to="/gorusmeform/0" class="nk-menu-link">
                  <span class="nk-menu-icon">
                    <em class="icon ni ni-msg-circle-fill"></em>
                  </span>
                  <span class="nk-menu-text">Yeni Görüşme Ekle</span>
                </router-link>
              </li>

          

     



              <li class="nk-menu-heading">
                <h6 class="overline-title text-primary-alt">Menü</h6>
              </li>

         
              <li class="nk-menu-item" v-if="yetki_kontrol('firma_ekle')" :class="aktifSayfa('/firmalar')">
                <router-link to="/firmalar" class="nk-menu-link">
                  <span class="nk-menu-icon">
                    <em class="icon ni ni-building"></em>
                  </span>
                  <span class="nk-menu-text">Firmalar</span>
                </router-link>
              </li>

              
              <li class="nk-menu-item" v-if="yetki_kontrol('kisi_ekle')" :class="aktifSayfa('/kisiler')">
                <router-link to="/kisiler" class="nk-menu-link">
                  <span class="nk-menu-icon">
                    <em class="icon ni ni-user-alt"></em>
                  </span>
                  <span class="nk-menu-text">Kişiler</span>
                </router-link>
              </li>

              <li class="nk-menu-item" v-if="yetki_kontrol('etkinlik_ekle')" :class="aktifSayfa('/etkinlikler')">
                <router-link to="/etkinlikler" class="nk-menu-link">
                  <span class="nk-menu-icon">
                    <em class="icon ni ni-ticket"></em>
                  </span>
                  <span class="nk-menu-text">Etkinlikler</span>
                </router-link>
              </li>

              <li class="nk-menu-item" v-if="yetki_kontrol('gorusmebilgi_ekle')"  :class="aktifSayfa('/gorusmebilgiler')">
                <router-link to="/gorusmebilgiler" class="nk-menu-link">
                  <span class="nk-menu-icon">
                    <em class="icon ni ni-update"></em>
                  </span>
                  <span class="nk-menu-text">Görüşmeler</span>
                </router-link>
              </li>


              <li class="nk-menu-heading">
                <h6 class="overline-title text-primary-alt">Sistem Menü</h6>
              </li>

          

              <li class="nk-menu-item" :class="aktifSayfa('/kullanicilar')" v-if="yetki_kontrol('kullanici_ekle')">
                  <router-link to="/kullanicilar" class="nk-menu-link" title="Kullanıcılar">
                    <span class="nk-menu-icon">
                      <em class="icon ni ni-user-c"></em>
                    </span>
                    <span class="nk-menu-text">Kullanıcılar</span>
                  </router-link>
                </li>
                <li class="nk-menu-item" :class="aktifSayfa('/roller')" v-if="yetki_kontrol('rol_ekle')">
                  <router-link to="/roller" class="nk-menu-link" title="Yetkiler">
                    <span class="nk-menu-icon">
                      <em class="icon ni ni-shield"></em>
                    </span>
                    <span class="nk-menu-text">Roller</span>
                  </router-link>
                </li>
                <li class="nk-menu-item" :class="aktifSayfa('/yedekler')" >
                  <router-link to="/yedekler" class="nk-menu-link" title="Yedekler">
                    <span class="nk-menu-icon">
                      <em class="icon ni ni-hard-drive"></em>
                    </span>
                    <span class="nk-menu-text">Yedeklemeler</span>
                  </router-link>
                </li>




            </ul>
          </div>
        </div>
        <div class="nk-content ">


          <slot></slot>

        </div>

      </div>
    </div>
  </div>

</template>


  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';


import logoIcon from '@/assets/images/logo.png';

export default {
  data() {
    return {
      gorsel: {
      'logoIcon': logoIcon, 
      },
      menuActive:false,
      profil:{}
    };
  },
  mounted() {
this.profilGetir();
this.updateBodyClass();
},
 
  methods: {
    yetki_kontrol(yetki) {
      return yetkiKontrol(yetki);
    },
   
    async profilGetir() {
    try {
      const response = await axiosCustom.get("profil"); 
      this.profil = response.data;
    } catch (error) {
      console.error("Profil alma hatası: ", error);
    }
    },
    aktifSayfa(route) {
      return this.$route.path === route ? 'active current-page' : '';
    },
    toggleMenu() {
      this.menuActive = !this.menuActive;

      var bodyElement = document.body;
      var yanMenu = document.getElementById('menuYan');

      // Tüm mevcut sınıfları temizleyin
      bodyElement.className = '';
      yanMenu.className = '';

      // Yeni sınıfları ekleyin
      if (this.menuActive) {
        bodyElement.classList.add('nk-body', 'npc-default', 'has-apps-sidebar', 'has-sidebar', 'no-touch', 'nk-nio-theme', 'nav-shown');
        yanMenu.classList.add('nk-sidebar', 'is-light', 'has-apps-sidebar', 'nk-sidebar-mobile', 'nk-sidebar-active');
      } else {
        bodyElement.classList.add('nk-body', 'npc-default', 'has-apps-sidebar', 'has-sidebar');
        yanMenu.classList.add('nk-sidebar', 'is-light', 'has-apps-sidebar', 'nk-sidebar-mobile');
      }
    },
    updateBodyClass() {
                const currentPath = this.$route.path;
                const bodyElement = document.body;
    
                if (currentPath === '/login') {
                bodyElement.className = 'nk-body npc-default pg-auth no-touch nk-nio-theme';
                } else {
                bodyElement.className = 'nk-body npc-default has-apps-sidebar has-sidebar';
                }
            }
  },
};
</script>
  